var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"content small-align-center"},[_c('div',{staticClass:"row"},[(_vm.contactsEnabled)?_c('FooterPhone'):_vm._e(),_c('FooterSocial')],1),_c('FooterCopyright')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }